var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { commonCssStyles } from "../../global-styles.js";
import { ifDefined } from "lit/directives/if-defined.js";
let FooterLegalLink = class FooterLegalLink extends LitElement {
    constructor() {
        super(...arguments);
        this.disabled = false;
    }
    render() {
        return html `<a
      class="container ${classMap({ disabled: this.disabled })}"
      href="${this.href ? this.href : "javascript:;"}"
      target="${ifDefined(this.target)}"
    >
      <div class="container-rule">
        <div class="label text-body-s-regular">
          ${this.text}
          <div class="rule"></div>
        </div>
      </div>
      <svg
        class="icon"
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          id="arrow-up-right"
          d="M11.375 3.30859V9.87109C11.375 10.2539 11.0742 10.5273 10.7188 10.5273C10.3359 10.5273 10.0625 10.2539 10.0625 9.87109V4.89453L3.74609 11.2109C3.60938 11.3477 3.44531 11.4023 3.28125 11.4023C3.08984 11.4023 2.92578 11.3477 2.81641 11.2109C2.54297 10.9648 2.54297 10.5547 2.81641 10.3086L9.13281 3.96484H4.15625C3.77344 3.96484 3.5 3.69141 3.5 3.30859C3.5 2.95312 3.77344 2.65234 4.15625 2.65234H10.7188C11.0742 2.65234 11.375 2.95312 11.375 3.30859Z"
        />
      </svg>
    </a>`;
    }
};
// noinspection CssUnresolvedCustomProperty,CssNoGenericFontName
FooterLegalLink.styles = [
    commonCssStyles,
    css `
      .container {
        text-decoration: none;
        display: inline-flex;
        align-items: center;
        gap: var(--spacing-xs);
        padding: 0 var(--spacing-2xs);
      }

      .container .icon {
        fill: var(--tones-lavender50-color);
      }

      .container * {
        transition: var(--delay-transition75);
      }

      .container-rule {
        background-color: transparent;
        border: none;
        margin: 0;
        padding: 2px 0;
        text-align: inherit;
        font: inherit;
        border-radius: 0;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        text-decoration: none;
      }

      .label {
        color: var(--tones-lavender50-color);
        display: flex;
        align-items: center;
        border-radius: 4px;
        text-align: center;
        min-width: max-content;
        line-height: normal;
        flex-direction: column;
      }

      .rule {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        align-self: stretch;
        height: 2px;
        background: var(--tones-lavender50-color);
        width: 0;
      }

      .container:focus-visible {
        gap: var(--spacing-xs);
        border-radius: 4px;
        outline: 2px solid var(--Color-color-lavender-50, #794dff);
      }

      .container:hover {
        cursor: pointer;
      }

      .container:hover .icon {
        fill: var(--tones-lavender60-color);
      }

      .container:hover .container-rule .label {
        color: var(--tones-lavender60-color);
      }

      .container:hover .container-rule .label .rule {
        width: 100%;
        background-color: var(--tones-lavender60-color);
      }

      .container:active .icon {
        fill: var(--tones-lavender70-color);
      }

      .container:active .container-rule .label {
        color: var(--tones-lavender70-color);
      }

      .container:active .container-rule .label .rule {
        width: 100%;
        background-color: var(--tones-lavender70-color);
      }

      .container.disabled {
        pointer-events: none;
      }

      .container.disabled .icon {
        fill: var(--tones-lavender60-disabled-color);
      }

      .container.disabled .container-rule .label {
        color: var(--tones-lavender60-disabled-color);
      }

      .container.disabled .container-rule .label .rule {
        width: 0;
      }
    `,
];
__decorate([
    property()
], FooterLegalLink.prototype, "text", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], FooterLegalLink.prototype, "disabled", void 0);
__decorate([
    property()
], FooterLegalLink.prototype, "href", void 0);
__decorate([
    property()
], FooterLegalLink.prototype, "target", void 0);
FooterLegalLink = __decorate([
    customElement("footer-legal-link")
], FooterLegalLink);
export { FooterLegalLink };
